export default __webpack_public_path__ + "static/media/logo_blue_main.1fd32e5a.png";